import { extractData } from '@/models';
import api from '@/services/api';
import type { Asset, Wallet } from '@/types';

const apiUrl = WEB_WALLETS_API_HOST;

export default {
    listWallets() {
        return api()
            .get<{ data: Wallet[] }>(`${ apiUrl }/public/web-wallets/v3/wallets`)
            .then(extractData).then(res => res.data);
    },
    renameWallet(assetId: string, walletAddress: string, walletName: string) {
        return api()
            .put(`${ apiUrl }/public/web-wallets/v2/wallets/name`, {
                assetId,
                address: walletAddress,
                name: walletName,
            });
    },
    listAssets() {
        return api()
            .get<{ data: Asset[] }>(`${ apiUrl }/public/web-wallets/v1/assets/supported`)
            .then(extractData).then(res => res.data);
    },
};
